/**
 * @generated SignedSource<<f0cd509e142f69bcae46da270cdbb1c1>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum PublicLinkPermissionsObjectType {
  CONTENT = "CONTENT",
}
export enum PublicLinkPermissionsType {
  EDIT = "EDIT",
}
export type usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery_publicLinkPermissionsForObject_PublicLinkPermissions =
  {
    __typename?: "PublicLinkPermissions";
    permissions: Array<PublicLinkPermissionsType>;
  };
export type usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery_Query =
  {
    __typename?: "Query";
    publicLinkPermissionsForObject: usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery_publicLinkPermissionsForObject_PublicLinkPermissions | null;
  };
export type usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQueryVariables =
  Exact<{
    objectId: Scalars["ID"]["input"];
    objectType: PublicLinkPermissionsObjectType;
  }>;
export type usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery =
  usePublicLinkPermissionsForObjectPublicLinkPermissionsForObjectQuery_Query;
